import React, { useState } from "react";
import "./ViewAssignment.css";

const API_URL = "https://aadyaacademy.org/api";

const ViewAssignment = ({ assignment, closeDetail }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Format date from YYYY-MM-DD to DD/MM/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Construct URL for attachment
  const getAttachmentUrl = (url) => {
    if (!url) return null;
    // Extract the file path (e.g., 'uploads/rtyuiojkjhgfvcsaertyu.pdf') from the URL
    const filePath = url.split('/uploads/')[1];
    return filePath ? `${API_URL}/uploads/${filePath}` : null;
  };

  if (loading) {
    return (
      <div className="view-container">
        <div className="view-assignment">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="view-container">
        <div className="view-assignment">
          <h2>{error}</h2>
          <div className="view-actions">
            <button onClick={closeDetail} className="view-cancel">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!assignment) {
    return (
      <div className="view-container">
        <div className="view-assignment">
          <h2>Assignment not found.</h2>
          <div className="view-actions">
            <button onClick={closeDetail} className="view-cancel">
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="view-container">
      <div className="view-assignment">
        <div className="view-header">
          <h2>Assignment Details</h2>
        </div>
        <div className="assignment-class-section-subject">
          <div className="assignment-class">
            <div className="class-field">{assignment.class || "N/A"}</div>
            <h4>Class</h4>
          </div>
          <div className="assignment-section">
            <div className="section-field">{assignment.section || "N/A"}</div>
            <h4>Section</h4>
          </div>
          <div className="assignment-subject">
            <div className="subject-field">{assignment.subject || "N/A"}</div>
            <h4>Subject</h4>
          </div>
        </div>
        <div className="assignment-due-date-day">
          <div className="assignment-due-date">
            <div className="due-date-field">{formatDate(assignment.date)}</div>
            <h4>Due Date</h4>
          </div>
          <div className="assignment-day">
            <div className="day-field">{assignment.day || "N/A"}</div>
            <h4>Day</h4>
          </div>
        </div>
        <div className="assignment-text-message">
          <div className="text-message-field">
            {assignment.text_message ? assignment.text_message : "None"}
          </div>
          <h4>Text Message</h4>
        </div>
        <div className="assignment-attachment">
          <div className="attachment-field">
            {assignment.attachmentUrl ? (
              <a
                href={getAttachmentUrl(assignment.attachmentUrl)}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Attachment
              </a>
            ) : (
              "None"
            )}
          </div>
          <h4>Attachment</h4>
        </div>
        <div className="view-actions">
          <button onClick={closeDetail} className="view-cancel">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewAssignment;